<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Simulador"
    size="lg"
    hide-footer
    body-class="pb-0"
  >
    <div class="container-fluid">
      <!-- Controles -->
      <div class="row">
        <div class="col-md-4 mb-3">
          <div class="border rounded p-3 bg-white">
            <div class="text-muted small mb-2">Numerador</div>
            <b-form-input
              type="range"
              min="0"
              :max="this.maxValor"
              :value="nManual"
              @input="setNumerador($event)"
            />
            <b-form-input
              type="number"
              min="0"
              :max="this.maxValor"
              class="mt-2 text-center"
              :value="nManual"
              @input="setNumerador($event)"
            />
            <div
              v-if="deltaNumerador !== 0"
              class="delta"
              :class="deltaClassNumerador"
            >
              {{ formatDelta(deltaNumerador) }}
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div class="border rounded p-3 bg-white">
            <div class="text-muted small mb-2">Denominador</div>
            <b-form-input
              type="range"
              min="1"
              :max="this.maxValor"
              :value="dManual"
              @input="setDenominador($event)"
            />
            <b-form-input
              type="number"
              min="1"
              :max="this.maxValor"
              class="mt-2 text-center"
              :value="dManual"
              @input="setDenominador($event)"
            />
            <div
              v-if="deltaDenominador !== 0"
              class="delta"
              :class="deltaClassDenominador"
            >
              {{ formatDelta(deltaDenominador) }}
            </div>
          </div>
        </div>

        <div class="col-md-4 mb-3">
          <div
            class="border rounded p-3 bg-white text-center h-100 d-flex flex-column justify-content-center"
          >
            <div class="text-muted small">Resultado (N/D × 100)</div>
            <div class="display-4 font-weight-bold">{{ resultado }}%</div>
            <b-badge class="mt-2 px-3 py-2" :variant="classe.variant">
              {{ classe.nivel }}
            </b-badge>
          </div>
        </div>
      </div>

      <!-- Classificação (presets) -->
      <div class="border rounded bg-white p-3 mb-3">
        <!-- <h5 class="mb-3">Classificação</h5> -->
        <div class="sim-grid">
          <div
            v-for="tipo in TIPOS"
            :key="tipo"
            class="sim-chip"
            :class="chipClass(tipo)"
            @click="aplicarPreset(tipo)"
          >
            <div class="sim-chip-title">{{ tipo }}</div>
            <div class="sim-chip-sub">
              <span v-if="tipo === 'Ótimo'">>= 8 e < 10</span>
              <span v-else-if="tipo === 'Bom'">>= 10 e < 12</span>
              <span v-else-if="tipo === 'Suficiente'">>= 12 e < 14</span>
              <span v-else>< 8 e >= 14</span>
            </div>
          </div>
        </div>

        <div class="mt-2 text-muted small">
          Dica: os botões preenchem valores de exemplo (N = x, D = 100). Você
          pode ajustar pelos controles acima.
        </div>

        <!-- Legenda -->
        <div class="mt-4">
          <!-- <h6 class="mb-2">Legenda</h6> -->
          <div class="row">
            <div class="col-md-12">
              <strong>Numerador</strong>
              <ul class="mb-3 pl-3">
                <li v-for="p in PROCEDIMENTOS_NUMERADOR" :key="p.codigo">
                  {{ p.codigo }} – {{ p.desc }}
                </li>
              </ul>
            </div>
            <div class="col-md-12">
              <strong>Denominador</strong>
              <ul class="mb-0 pl-3">
                <li v-for="p in PROCEDIMENTOS_DENOMINADOR" :key="p.codigo">
                  {{ p.codigo }} – {{ p.desc }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'SimuladorOdontoModal',
  props: {
    modalId: { type: String, default: 'simulador-odonto-modal' },
    dadosPercentualMunicipio: {
      type: Object,
      default: () => {},
    },
    dadosPercentualEquipe: {
      type: Object,
      default: () => {},
    },
    dadosPercentualMicroArea: {
      type: Object,
      default: () => {},
    },
    selectedEquipe: {
      type: [Object, String],
      default: '',
    },
    selectedMicroArea: {
      type: [Object, String],
      default: '',
    },
  },
  data() {
    return {
      maxValor: 1000000,
      nManual: 0,
      dManual: 1,
      baseNumerador: 0,
      baseDenominador: 1,
      TIPOS: ['Ótimo', 'Bom', 'Suficiente', 'Regular'],
      PROCEDIMENTOS_NUMERADOR: [
        { codigo: '04.14.02.013-8', desc: 'Exodontia de dente permanente' },
        {
          codigo: '04.14.02.014-6',
          desc: 'Exodontia múltipla com alveoloplastia por sextante',
        },
      ],
      PROCEDIMENTOS_DENOMINADOR: [
        {
          codigo: '01.01.02.005-8',
          desc: 'Aplicação de cariostático (por dente)',
        },
        { codigo: '01.01.02.006-6', desc: 'Aplicação de selante (por dente)' },
        {
          codigo: '01.01.02.007-4',
          desc: 'Aplicação tópica de flúor (individual por sessão)',
        },
        { codigo: '01.01.02.008-2', desc: 'Evidenciação de placa bacteriana' },
        {
          codigo: '01.01.02.009-0',
          desc: 'Selamento provisório de cavidade dentária',
        },
        { codigo: '03.07.01.001-5', desc: 'Capeamento pulpar' },
        {
          codigo: '03.07.01.003-1',
          desc: 'Restauração de dente permanente anterior com resina composta',
        },
        {
          codigo: '03.07.01.006-6',
          desc: 'Tratamento inicial do dente traumatizado',
        },
        {
          codigo: '03.07.01.007-4',
          desc: 'Tratamento restaurador atraumático (TRA/ART)',
        },
        {
          codigo: '03.07.01.008-2',
          desc: 'Restauração de dente decíduo posterior com resina composta',
        },
        {
          codigo: '03.07.01.010-4',
          desc: 'Restauração de dente decíduo posterior com ionômero de vidro',
        },
        {
          codigo: '03.07.01.011-2',
          desc: 'Restauração de dente decíduo anterior com resina composta',
        },
        {
          codigo: '03.07.01.012-0',
          desc: 'Restauração de dente permanente posterior com resina composta',
        },
        {
          codigo: '03.07.01.013-9',
          desc: 'Restauração de dente permanente posterior com amálgama',
        },
        {
          codigo: '03.07.02.001-0',
          desc: 'Acesso à polpa dentária e medicação (por dente)',
        },
        {
          codigo: '03.07.02.002-9',
          desc: 'Curativo de demora com ou sem preparo biomecânico',
        },
        { codigo: '03.07.02.007-0', desc: 'Pulpotomia dentária' },
        {
          codigo: '03.07.03.002-4',
          desc: 'Raspagem e alisamento subgengivais (por sextante)',
        },
        {
          codigo: '03.07.03.004-0',
          desc: 'Profilaxia / remoção da placa bacteriana',
        },
        {
          codigo: '03.07.03.005-9',
          desc: 'Raspagem, alisamento e polimento supragengivais (por sextante)',
        },
        {
          codigo: '03.07.03.006-7',
          desc: 'Tratamento de gengivite ulcerativa necrosante aguda (GUNA)',
        },
        {
          codigo: '03.07.03.007-5',
          desc: 'Tratamento de lesões da mucosa oral',
        },
        { codigo: '03.07.03.008-3', desc: 'Tratamento de pericoronarite' },
        { codigo: '04.14.02.013-8', desc: 'Exodontia de dente permanente' },
        {
          codigo: '04.14.02.014-6',
          desc: 'Exodontia múltipla com alveoloplastia por sextante',
        },
      ],
    }
  },
  computed: {
    resultado() {
      const d = Number(this.dManual) || 0
      if (d <= 0) return 0
      const n = Number(this.nManual) || 0
      return Number(((n / d) * 100).toFixed(2))
    },
    classe() {
      const r = this.resultado
      if (r >= 8 && r < 10) return { nivel: 'Ótimo', variant: 'primary' }
      if (r >= 10 && r < 12) return { nivel: 'Bom', variant: 'success' }
      if (r >= 12 && r < 14) return { nivel: 'Suficiente', variant: 'warning' }
      if (r < 8 && r >= 14) return { nivel: 'Regular', variant: 'danger' }
      return { nivel: 'Regular', variant: 'danger' }
    },
    deltaNumerador() {
      return (Number(this.nManual) || 0) - (Number(this.baseNumerador) || 0)
    },
    deltaDenominador() {
      return (Number(this.dManual) || 1) - (Number(this.baseDenominador) || 1)
    },
    deltaClassNumerador() {
      return this.deltaClass(this.deltaNumerador)
    },
    deltaClassDenominador() {
      return this.deltaClass(this.deltaDenominador)
    },
  },
  watch: {
    selectedMicroArea: 'aplicarFonte',
    selectedEquipe: 'aplicarFonte',
    dadosPercentualMunicipio: { handler: 'aplicarFonte', deep: true },
    dadosPercentualEquipe: { handler: 'aplicarFonte', deep: true },
    dadosPercentualMicroArea: { handler: 'aplicarFonte', deep: true },
  },
  mounted() {
    this.aplicarFonte()
  },
  methods: {
    chipClass(tipo) {
      return {
        'sim-chip--otimo': tipo === 'Ótimo',
        'sim-chip--bom': tipo === 'Bom',
        'sim-chip--suficiente': tipo === 'Suficiente',
        'sim-chip--regular': tipo === 'Regular',
      }
    },

    setNumerador(v) {
      const num = Math.max(0, Math.min(this.maxValor, Number(v) || 0))
      this.nManual = num
    },

    setDenominador(v) {
      const num = Math.max(1, Math.min(this.maxValor, Number(v) || 1))
      this.dManual = num
    },

    resetBase() {
      this.baseNumerador = this.nManual
      this.baseDenominador = this.dManual
    },

    aplicarPreset(tipo) {
      if (tipo === 'Ótimo') {
        this.setNumerador(8)
        this.setDenominador(100)
      } else if (tipo === 'Bom') {
        this.setNumerador(10)
        this.setDenominador(100)
      } else if (tipo === 'Suficiente') {
        this.setNumerador(12)
        this.setDenominador(100)
      } else if (tipo === 'Regular') {
        this.setNumerador(7)
        this.setDenominador(100)
      }

      this.resetBase()
    },

    aplicarFonte() {
      let fonte = null
      if (this.selectedMicroArea) {
        fonte = this.dadosPercentualMicroArea
      } else if (this.selectedEquipe) {
        fonte = this.dadosPercentualEquipe
      } else {
        fonte = this.dadosPercentualMunicipio
      }

      const n = fonte && fonte.numerador != null ? fonte.numerador : 0
      const d = fonte && fonte.denominador != null ? fonte.denominador : 1

      this.setNumerador(n)
      this.setDenominador(d)

      this.resetBase()
    },

    open() {
      this.aplicarFonte()
      this.$refs.modal.show()
    },

    close() {
      this.$refs.modal.hide()
    },

    formatDelta(val) {
      if (val > 0) return `+${val}`
      if (val < 0) return `${val}`
      return ''
    },

    deltaClass(val) {
      if (val > 0) return 'delta--pos'
      if (val < 0) return 'delta--neg'
      return 'delta--zero'
    },
  },
}
</script>

<style scoped lang="scss">
$cor-otimo-bg: #e3f2fd;
$cor-otimo-border: #bbdefb;
$cor-otimo-text: #0d47a1;

$cor-bom-bg: #e8f5e9;
$cor-bom-border: #c8e6c9;
$cor-bom-text: #1b5e20;

$cor-suficiente-bg: #fff3e0;
$cor-suficiente-border: #ffe0b2;
$cor-suficiente-text: #e65100;

$cor-regular-bg: #ffebee;
$cor-regular-border: #ffcdd2;
$cor-regular-text: #b71c1c;

.sim-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;

  @media (max-width: 576px) {
    grid-template-columns: repeat(2, 1fr);
  }
}

.sim-chip {
  display: block;
  width: 100%;
  border-radius: 14px;
  border: 1px solid transparent;
  padding: 10px 14px;
  text-align: left;
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.02s ease;
  line-height: 1.2;
  background: #fff;
  text-align: center;
  padding: 20px;

  &-title {
    font-weight: 600;
  }

  &-sub {
    font-size: 12px;
    opacity: 0.85;
    margin-top: 2px;
  }

  &:active {
    transform: translateY(1px);
  }

  &:hover {
    box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.03);
  }

  &--otimo {
    background: $cor-otimo-bg;
    border-color: $cor-otimo-border;
    color: $cor-otimo-text;
  }

  &--bom {
    background: $cor-bom-bg;
    border-color: $cor-bom-border;
    color: $cor-bom-text;
  }

  &--suficiente {
    background: $cor-suficiente-bg;
    border-color: $cor-suficiente-border;
    color: $cor-suficiente-text;
  }

  &--regular {
    background: $cor-regular-bg;
    border-color: $cor-regular-border;
    color: $cor-regular-text;
  }
}

.delta {
  font-size: 15px;
  margin-top: 6px;
  font-weight: 600;
  text-align: center;

  &--pos {
    color: #1b5e20;
  } /* verde */
  &--neg {
    color: #b71c1c;
  } /* vermelho */
  &--zero {
    color: #6c757d;
  } /* cinza */
}
</style>
